import { render, staticRenderFns } from "./EditDepartmentInformation.vue?vue&type=template&id=17791a2e&scoped=true&"
import script from "./EditDepartmentInformation.vue?vue&type=script&lang=js&"
export * from "./EditDepartmentInformation.vue?vue&type=script&lang=js&"
import style0 from "./EditDepartmentInformation.vue?vue&type=style&index=0&id=17791a2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17791a2e",
  null
  
)

export default component.exports